module.exports = __webpack_public_path__ + "img/usdc.a0d924d8.svg";